import React, { useState, useEffect } from "react";
import News from "./News";
import Slider from "react-slick";
import { getSlider } from "../Service/Api";

const HomeSlider = () => {
  const [sliderData, setSliderData] = useState([]);
  const [sliderRef, setSliderRef] = useState(null);

  useEffect(() => {
    async function getSliderApi() {
      try {
        const res = await getSlider();
        console.log(res);
        setSliderData(res);
      } catch (err) {
        console.error(err);
      }
    }

    getSliderApi();
  }, []);

  const settings = {
    autoplay: true,
    infinite: true,
    autoplaySpeed: 3000,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
    adaptiveHeight: true,
  };

  return (
    <>
      <div className="slider-sec">
        <div className="news">
          <News />
        </div>

        <div className="homeslider">
          <Slider ref={(slider) => setSliderRef(slider)} {...settings}>
            {sliderData.length === 0 && (
              <div className="item">
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CCSDH/public/Images/slider0.jpg"
                  alt="CCSDH"
                  className="img-fluid"
                />
              </div>
            )}

            {sliderData &&
              sliderData.map((item) => (
                <div className="item" key={item._id}>
                  <img
                    src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachment}`}
                    alt={item.title || "slider"}
                    className="img-fluid"
                  />
                </div>
              ))}
          </Slider>

          {/* Custom arrows */}
          <button
            type="button"
            className="slider-arrow slider-prev"
            onClick={() => sliderRef?.slickPrev()}
          >
            &#10094;
          </button>

          <button
            type="button"
            className="slider-arrow slider-next"
            onClick={() => sliderRef?.slickNext()}
          >
            &#10095;
          </button>
        </div>
      </div>
    </>
  );
};

export default HomeSlider;